import styled from '@emotion/styled'
import { ButtonProps, PharmacButtonBase, PharmacIcon } from '@pharmac/ui'

const EditButton = styled(PharmacButtonBase)`
  border: solid 2px var(--color-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
`

export const ExtranetEditButton = (props: ButtonProps & { onClick: () => void }) => {
  const { onClick, ...buttonProps } = props
  return (
    <EditButton
      onClick={onClick}
      {...buttonProps}
    >
      <PharmacIcon
        size="15"
        icon="edit3"
        stroke="purple"
      />
    </EditButton>
  )
}
